import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import { exhaustiveCheck } from "@octopusdeploy/type-utils";
import type { ReactNode } from "react";
import type { NonPrimaryWorkflowAction, PrimaryWorkflowAction, WorkflowAction } from "~/workflows/WorkflowAction";
interface RenderWorkflowActionsProps {
    primaryWorkflowAction: PrimaryWorkflowAction | undefined;
    workflowActions: NonPrimaryWorkflowAction[];
    disableCancelButton: boolean;
    onCancelClicked: () => void;
    hideCancelButton: boolean;
}
export function renderWorkflowActions({ onCancelClicked, workflowActions, disableCancelButton, primaryWorkflowAction, hideCancelButton }: RenderWorkflowActionsProps): ReactNode[] {
    const actionNodes: ReactNode[] = [];
    if (!hideCancelButton) {
        actionNodes.push(<ActionButton key="Cancel" type={ActionButtonType.Secondary} label="Cancel" onClick={onCancelClicked} disabled={disableCancelButton}/>);
    }
    actionNodes.push(...workflowActions.map((workflowAction) => <WorkflowActionComponent key={workflowAction.label} workflowAction={workflowAction} buttonType={getActionButtonType(workflowAction.buttonType)}/>));
    if (primaryWorkflowAction !== undefined) {
        actionNodes.push(<WorkflowActionComponent key={primaryWorkflowAction.label} workflowAction={primaryWorkflowAction} buttonType={ActionButtonType.Primary}/>);
    }
    return actionNodes;
}
function getActionButtonType(buttonType: NonPrimaryWorkflowAction["buttonType"]) {
    switch (buttonType) {
        case "destructive":
            return ActionButtonType.Delete;
        case "secondary":
            return ActionButtonType.Secondary;
        case "tertiary":
            return ActionButtonType.Ternary;
        default:
            exhaustiveCheck(buttonType, "Not all button types have been handled");
    }
}
interface WorkflowActionComponentProps {
    workflowAction: WorkflowAction;
    buttonType: ActionButtonType;
}
function WorkflowActionComponent({ buttonType, workflowAction: { label, accessibleName, busyLabel, disabled, onClick, formId, menuButtonAttributes, icon, hasPermissions } }: WorkflowActionComponentProps) {
    return (<ActionButton label={label} type={buttonType} accessibleName={accessibleName} busyLabel={busyLabel} disabled={hasPermissions === false || disabled} onClick={onClick} formId={formId} menuButtonAttributes={menuButtonAttributes} icon={icon}/>);
}
